/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCenterStockItemUpdateBase
 */
export interface MstCenterStockItemUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItemUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItemUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItemUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItemUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItemUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItemUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItemUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItemUpdateBase
     */
    companyId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItemUpdateBase
     */
    centerId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItemUpdateBase
     */
    orgCenterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItemUpdateBase
     */
    orgItemCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItemUpdateBase
     */
    orgSupplierId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItemUpdateBase
     */
    stockDaysSetting?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItemUpdateBase
     */
    safetyStockSetting?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItemUpdateBase
     */
    minStockQuantity?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItemUpdateBase
     */
    orderUnitType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItemUpdateBase
     */
    caseLot?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterStockItemUpdateBase
     */
    minOrderQuantity?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItemUpdateBase
     */
    startDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItemUpdateBase
     */
    stopShip?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItemUpdateBase
     */
    stopArrival?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterStockItemUpdateBase
     */
    salesEndAlertDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterStockItemUpdateBase
     */
    remarks?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItemUpdateBase
     */
    isDiscontinued?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterStockItemUpdateBase
     */
    isMuted?: boolean | null;
}

/**
 * Check if a given object implements the MstCenterStockItemUpdateBase interface.
 */
export function instanceOfMstCenterStockItemUpdateBase(value: object): value is MstCenterStockItemUpdateBase {
    return true;
}

export function MstCenterStockItemUpdateBaseFromJSON(json: any): MstCenterStockItemUpdateBase {
    return MstCenterStockItemUpdateBaseFromJSONTyped(json, false);
}

export function MstCenterStockItemUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCenterStockItemUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'centerId': json['center_id'] == null ? undefined : json['center_id'],
        'orgCenterId': json['org_center_id'] == null ? undefined : json['org_center_id'],
        'orgItemCode': json['org_item_code'] == null ? undefined : json['org_item_code'],
        'orgSupplierId': json['org_supplier_id'] == null ? undefined : json['org_supplier_id'],
        'stockDaysSetting': json['stock_days_setting'] == null ? undefined : json['stock_days_setting'],
        'safetyStockSetting': json['safety_stock_setting'] == null ? undefined : json['safety_stock_setting'],
        'minStockQuantity': json['min_stock_quantity'] == null ? undefined : json['min_stock_quantity'],
        'orderUnitType': json['order_unit_type'] == null ? undefined : json['order_unit_type'],
        'caseLot': json['case_lot'] == null ? undefined : json['case_lot'],
        'minOrderQuantity': json['min_order_quantity'] == null ? undefined : json['min_order_quantity'],
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'stopShip': json['stop_ship'] == null ? undefined : json['stop_ship'],
        'stopArrival': json['stop_arrival'] == null ? undefined : json['stop_arrival'],
        'salesEndAlertDate': json['sales_end_alert_date'] == null ? undefined : (new Date(json['sales_end_alert_date'])),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'isDiscontinued': json['is_discontinued'] == null ? undefined : json['is_discontinued'],
        'isMuted': json['is_muted'] == null ? undefined : json['is_muted'],
    };
}

export function MstCenterStockItemUpdateBaseToJSON(json: any): MstCenterStockItemUpdateBase {
    return MstCenterStockItemUpdateBaseToJSONTyped(json, false);
}

export function MstCenterStockItemUpdateBaseToJSONTyped(value?: MstCenterStockItemUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_center_id': value['orgCenterId'],
        'org_item_code': value['orgItemCode'],
        'org_supplier_id': value['orgSupplierId'],
        'stock_days_setting': value['stockDaysSetting'],
        'safety_stock_setting': value['safetyStockSetting'],
        'min_stock_quantity': value['minStockQuantity'],
        'order_unit_type': value['orderUnitType'],
        'case_lot': value['caseLot'],
        'min_order_quantity': value['minOrderQuantity'],
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString().substring(0,10),
        'stop_ship': value['stopShip'],
        'stop_arrival': value['stopArrival'],
        'sales_end_alert_date': value['salesEndAlertDate'] == null ? value['salesEndAlertDate'] : value['salesEndAlertDate'].toISOString().substring(0,10),
        'remarks': value['remarks'],
        'is_discontinued': value['isDiscontinued'],
        'is_muted': value['isMuted'],
    };
}

